import { createAllocationRoutes } from "features/allocations/AllocationRoutes";
import { createEntityEditRoutes } from "features/entities/edit/EntityEditRoutes";
import { getAllocationRuleListLoader } from "gen/endpoints/allocation-rule/allocation-rule";
import { getFundEntityTableDataRetrieveLoader } from "gen/endpoints/fund-entities-table-data/fund-entities-table-data";
import { getGlobalEntityTableDataRetrieveLoader } from "gen/endpoints/global-entity-table-data/global-entity-table-data";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";
import { composeLoaders } from "shared/utils/RoutingUtils";

export const fundFamilySetupEntitiesRoutes: RouteObject = {
  id: "fundFamilySetupEntities",
  path: "entities",
  children: [
    {
      id: "fundFamilySetupEntitiesIndex",
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { FundFamilySetupEntitiesPage } = await import(
          "features/fund-family/setup/entities/FundFamilySetupEntitiesPage"
        );
        return { Component: FundFamilySetupEntitiesPage };
      },
      children: [
        {
          id: "fundFamilySetupEntitiesList",
          path: "",
          lazy: async () => {
            const { FundFamilySetupEntitiesTabList } = await import(
              "features/fund-family/setup/entities/FundFamilySetupEntitiesTabList"
            );
            return { Component: FundFamilySetupEntitiesTabList };
          },
          handle: {
            title: i18n.t("entity:setup.entityList"),
          },
          loader: composeLoaders(
            getGlobalEntityTableDataRetrieveLoader(),
            getFundEntityTableDataRetrieveLoader(),
          ),
        },
        {
          id: "fundFamilySetupEntitiesAllocationsList",
          path: "allocations",
          lazy: async () => {
            const { FundFamilySetupEntitiesTabAllocationList } = await import(
              "features/fund-family/setup/entities/FundFamilySetupEntitiesTabAllocationList"
            );
            return { Component: FundFamilySetupEntitiesTabAllocationList };
          },
          handle: {
            title: i18n.t("entity:setup.allocationRules"),
          },
          loader: getAllocationRuleListLoader(),
        },
      ],
    },
    {
      id: "fundFamilySetupEntitiesEntity",
      path: ":entityId",
      children: [
        {
          id: "fundFamilySetupEntitiesEditPage",
          lazy: async () => {
            const { FundFamilySetupEntitiesEditPage } = await import(
              "features/fund-family/setup/entities/FundFamilySetupEntitiesEditPage"
            );
            return { Component: FundFamilySetupEntitiesEditPage };
          },
          children: createEntityEditRoutes("fundFamilySetup"),
        },
        createAllocationRoutes("fundFamilySetupEntitiesEntity"),
      ],
    },
    createAllocationRoutes("fundFamilySetupEntities"),
  ],
};
